import { reduxForm } from 'redux-form';
import { REPORT_HEALTH_INSURANCE_BONUS_FORM } from 'src/constants/FormNames';
import PdfModal from './PdfModal';

const PdfModalForm = reduxForm({
  form: REPORT_HEALTH_INSURANCE_BONUS_FORM
})(PdfModal);

export default PdfModalForm;
